import React from 'react'

function isZeroish(value) {
  return value === 0 || value === '0'
}

function StatTile({ label, value, icon }) {
  const display = value == null || value === '' ? '—' : value
  const zero = isZeroish(display)

  return (
    <div className={['dashboardStatTile', zero ? 'isZero' : ''].filter(Boolean).join(' ')}>
      <div className="dashboardStatTileTop">
        {icon ? <i className={`icn dashboardStatTileIcon ${icon}`} aria-hidden="true" /> : null}
        <span className="dashboardStatTileLabel">{label}</span>
      </div>
      <div className="dashboardStatTileValue">{display}</div>
    </div>
  )
}

/**
 * Grouped KPI overview — PeerMed UX:
 * featured goal + labeled sections (Department / My activity / Team)
 * flat tiles (no nested white cards).
 */
export function StatsCardGrid({ goal = null, sections = [], cards = [] }) {
  const hasSections = sections.some((section) => section.cards?.length)
  const hasLegacyCards = !hasSections && cards.length > 0

  if (!goal && !hasSections && !hasLegacyCards) {
    return (
      <p className="dashboardStatCardsEmpty">No stats available for this filter.</p>
    )
  }

  return (
    <div className="dashboardStatOverview">
      {goal ? (
        <div className="dashboardStatGoal">
          <div className="dashboardStatGoalCopy">
            <p className="dashboardStatGoalEyebrow">Target</p>
            <p className="dashboardStatGoalLabel">{goal.label || 'Case goal'}</p>
            {goal.hint ? <p className="dashboardStatGoalHint">{goal.hint}</p> : null}
          </div>
          <div className="dashboardStatGoalValue">
            {goal.value == null || goal.value === '' ? '—' : goal.value}
          </div>
        </div>
      ) : null}

      {hasSections
        ? sections
            .filter((section) => section.cards?.length)
            .map((section) => (
              <section key={section.title} className="dashboardStatSection">
                <div className="dashboardStatSectionHead">
                  <h3 className="dashboardStatSectionTitle">{section.title}</h3>
                  {section.subtitle ? (
                    <p className="dashboardStatSectionSubtitle">{section.subtitle}</p>
                  ) : null}
                </div>
                <div className="dashboardStatTiles">
                  {section.cards.map((card) => (
                    <StatTile
                      key={`${section.title}-${card.label}`}
                      label={card.label}
                      value={card.value}
                      icon={card.icon}
                    />
                  ))}
                </div>
              </section>
            ))
        : null}

      {hasLegacyCards ? (
        <div className="dashboardStatTiles">
          {cards.map((card) => (
            <StatTile
              key={card.label}
              label={card.label}
              value={card.value}
              icon={card.icon}
            />
          ))}
        </div>
      ) : null}
    </div>
  )
}

export default StatsCardGrid
